<script>
import DateUtils from '@/utils/dateUtils';
export default
{
    name: 'countdown',

    props:
    {
        date: { type: Date, required: true },
    },

    created ()
    {
        this.counterLabel = this.timeLeftToString();
        this.interval = setInterval(() =>
        {
            if (this.getRemainingMs() <= 0)
            {
                this.$emit('expired');
            }
            this.counterLabel = this.timeLeftToString();
        }, 1000);
    },

    render () 
    {
        return (
            <div class='countdown'>
                { this.counterLabel }
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            counterLabel: '',
            interval: null,
        }
    },

    destroyed ()
    {
        clearInterval(this.interval);
    },

    computed:
    {
        
    },

    methods:
    {
        getRemainingMs ()
        {
            return DateUtils.getUTCNow(this.date).getTime() - DateUtils.getUTCNow().getTime();
        },

        timeLeftToString ()
        {
            const remainingMs = this.getRemainingMs();
            const remainingSeconds = Math.floor(remainingMs / 1000);
            const remainingMinutes = Math.floor(remainingSeconds / 60);
            const remainingHours = Math.floor(remainingMinutes / 60);
            var remainingDays = Math.floor(remainingHours / 24);
            var toString = '';

            if (remainingSeconds % 60 > 0) toString += remainingSeconds % 60 + 's ';
            if (remainingMinutes % 60 > 0) toString += remainingMinutes % 60 + 'm ';
            if (remainingHours % 24 > 0) toString += remainingHours % 24 + 'h ';
            if (remainingDays > 0) toString += remainingDays + 'd ';

            return toString.trim();
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
.countdown
{
}
</style>


// WEBPACK FOOTER //
// src/components/Countdown.vue